import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: InstallationUpdateInput!
  ) {
    updateOneInstallation(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Instalação actualizada`, mutationTypes.UPDATE)
)

